import React, {
    useMemo,
    useContext,
} from 'react';
import PropTypes from 'prop-types';

import { ConfigContext } from '../ConfigProvider';
import { PromoCheckoutPatchedDishesContext } from '../PromoCheckoutMenuDishesAdapter';


import DishDetails from '../DishDetails';


export function DishDetailsSingle(props) {
    const {
        isEntered,
        initialDishId,
        basketDishes,
        buttonsDisabled,
        setRef,
    } = props;

    const {
        canChangePortionsCount,
    } = useContext(ConfigContext);

    const { dishesArray } = useContext(PromoCheckoutPatchedDishesContext);
    const initialDish = useMemo(() => {
        const dish = dishesArray.find((d) => d.id === initialDishId);
        return dish;
    }, [initialDishId, dishesArray]);

    const {
        originalPriceWithStep, discountPriceWithStep, price, dishCountStep, isSet,
    } = initialDish;
    const { portion } = basketDishes.find((bd) => {
        if (isSet) {
            return initialDish.dishes.includes(bd.id);
        }
        return bd.id === initialDishId;
    }) || { portion: 0 };

    const portionButtonProps = {
        buttonsDisabled,
        id: initialDishId,
        portion,
        dishCountStep,
        originalPriceWithStep,
        discountPriceWithStep,
        price,
        isInfoBlock: false,
    };

    return (
        <DishDetails
            isEntered={isEntered}
            isActive
            dish={initialDish}
            index={0}
            portionButtonProps={portionButtonProps}
            canChangePortionsCount={canChangePortionsCount}
            fillHeight
            setRef={setRef}
        />
    );
}

DishDetailsSingle.propTypes = {
    isEntered: PropTypes.bool.isRequired,
    initialDishId: PropTypes.string.isRequired,
    basketDishes: PropTypes.arrayOf(
        PropTypes.shape({}),
    ).isRequired,
    buttonsDisabled: PropTypes.bool.isRequired,
};
